import React from 'react';
import s from './styles.module.css'
import Wrapper from '../../components/wrapper';
import HeaderTitle from '../../components/header_title';

const PrivacyPolicy = () => {
  return (
    <div className={s.main}>
      <Wrapper>
        <HeaderTitle/>
        <h1>Политика конфиденциальности</h1>

        <h2>1. Введение</h2>

        <p>
          Добро пожаловать на сайт.
        </p>

        <p>
          Настоящая Политика конфиденциальности объясняет, как мы собираем, используем и защищаем персональные данные пользователей, посещающих сайт samzaim.ru.
        </p>

        <p>
          Мы соблюдаем требования законодательства о защите персональных данных, включая Общий регламент по защите данных Европейского союза (GDPR/RGPD).
        </p>

        <h2>2. Ответственный за обработку данных</h2>

        <p>
          Ответственным за обработку данных является физическое лицо — владелец сайта.
        </p>

        <h2>3. Какие данные мы собираем</h2>

        <p>
          Мы можем собирать информацию, которую пользователь предоставляет добровольно, а также технические данные автоматически.
        </p>

        <h3>Информация, предоставленная пользователем</h3>

        <ul>
          <li>Имя;</li>
          <li>Адрес электронной почты;</li>
          <li>Информация, указанная пользователем в сообщении.</li>
        </ul>

        <h3>Данные, собираемые автоматически</h3>

        <ul>
          <li>IP-адрес;</li>
          <li>Тип браузера;</li>
          <li>Информация об устройстве;</li>
          <li>Операционная система;</li>
          <li>Посещенные страницы;</li>
          <li>Время посещения сайта;</li>
          <li>Источник перехода.</li>
        </ul>

        <h2>4. Использование информации</h2>

        <p>
          Мы используем собранные данные для:
        </p>

        <ul>
          <li>Поддержки работы сайта;</li>
          <li>Улучшения пользовательского опыта;</li>
          <li>Анализа посещаемости;</li>
          <li>Ответов на обращения пользователей;</li>
          <li>Защиты сайта от злоупотреблений;</li>
          <li>Соблюдения требований законодательства.</li>
        </ul>

        <h2>5. Яндекс Метрика</h2>

        <p>
          Мы используем Яндекс Метрику для анализа использования сайта и улучшения контента.
        </p>

        <p>
          Яндекс Метрика может собирать:
        </p>

        <ul>
          <li>Посещенные страницы;</li>
          <li>Время посещения;</li>
          <li>Тип устройства;</li>
          <li>Браузер;</li>
          <li>Примерное местоположение пользователя.</li>
        </ul>

        <h2>6. Файлы Cookie</h2>

        <p>
          Наш сайт использует файлы cookie для улучшения работы сайта, анализа трафика и повышения удобства пользователей.
        </p>

        <p>
          Пользователь может изменить настройки cookie в своем браузере.
        </p>

        <h2>7. Сторонние сервисы</h2>

        <p>
          Сайт может содержать ссылки на сторонние ресурсы и партнерские сервисы.
        </p>

        <p>
          Мы не отвечаем за содержание и политику конфиденциальности сторонних сайтов.
        </p>

        <h2>8. Партнерские ссылки</h2>

        <p>
          Сайт может использовать партнерские ссылки.
        </p>

        <p>
          Если пользователь переходит по такой ссылке и выполняет определенное действие, мы можем получить комиссию без дополнительных расходов для пользователя.
        </p>

        <h2>9. Права пользователя</h2>

        <p>
          Пользователь имеет право:
        </p>

        <ul>
          <li>Получить доступ к своим данным;</li>
          <li>Исправить неточные данные;</li>
          <li>Удалить свои данные;</li>
          <li>Ограничить обработку данных;</li>
          <li>Запросить перенос данных.</li>
        </ul>
      </Wrapper>
    </div>
  );
};

export default PrivacyPolicy;
